import { FilterStringComponent, SearchQueryByFilter, SearchTemplate } from '../../../../../../generic-search-common/src'
import { useEffect, useState } from 'react'
import { PillSelected } from '../pill-selected'
import { flattenFiltersToSelected } from '../../../../../../generic-search-common/src'
import { FILTER_STRING_MAP } from '../../../../../../generic-search-common/src/constants'
import { SkeletonPill } from '@msaf/core-react'

export interface LabelledGroupCollapsedFiltersProps {
  modifyValues: () => void
  query: SearchQueryByFilter
  searchTemplate: SearchTemplate
  lookupResolver?: (value: string, optionsKey?: string, searchTypeKey?: string) => Promise<string>
}

export function LabelledGroupCollapsedFilters({
  modifyValues,
  query,
  searchTemplate,
  lookupResolver,
}: LabelledGroupCollapsedFiltersProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [displaySegments, setDisplaySegments] = useState<{
    [filter: string]: FilterStringComponent[][]
  }>({})

  useEffect(() => {
    async function getDisplaySegments() {
      setIsLoading(true)
      try {
        const segments = await flattenFiltersToSelected(query, searchTemplate, { lookupResolver })
        setDisplaySegments(segments)
      } catch {
        // TODO: Error handling
        setDisplaySegments({})
      }
      setIsLoading(false)
    }
    getDisplaySegments()
  }, [query, lookupResolver, searchTemplate])

  if (isLoading) {
    return <SkeletonPill />
  }

  const toRender = searchTemplate.filters.flatMap((f) => {
    if (!(f.filterKey in displaySegments)) {
      return []
    }

    const obj = []

    obj.push(
      <p className='c-key-value-pair__key' key={`${f.filterKey}-label`}>
        {f.label}:
      </p>,
    )

    displaySegments[f.filterKey].forEach((segments, i) => {
      const limitedSegments = segments.filter((seg: any) => {
        if (seg.operator === FILTER_STRING_MAP['>=']) {
          seg.operator = '>='
        } else if (seg.operator === FILTER_STRING_MAP['<=']) {
          seg.operator = '<='
        }
        return seg.operator !== 'like' && seg.operator !== 'is'
      })

      // Unlikely to re-render these, so index is fine as a key component
      obj.push(
        <PillSelected
          key={`${f.filterKey}-${i}`}
          isEnabled
          label={f.label}
          displaySegments={limitedSegments}
          modifyValues={modifyValues}
        />,
      )
    })

    return (
      <div
        className='c-key-value-pair c-key-value-pair--small c-key-value-pair--full-width'
        key={`${f.filterKey}-section`}
      >
        {obj}
      </div>
    )
  })

  return <>{toRender}</>
}
